export const breakPoints: [number, number, number] = [0, 768, 1024]
